export const TILE_MAPPER_VERSION = 'v1.2.101';

export const TILE_MAPPER_CDN_URL = {
  holdemMicro: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  holdemMedium: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_nl_holdem_medium.jpg`,
  holdemMicroV2: `https://thehub.rationalcdn.com/pokerTileImages/assets/themeV2/${TILE_MAPPER_VERSION}/pkr_nl_holdem_micro.jpg`,
  razzMicro: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_l_razz_micro.jpg`,
  satellite: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_satellite.jpg`,
  cashGamesIcon: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_icon_cash_games@2x.png`,
  tournamentsIcon: `https://thehub.rationalcdn.com/pokerTileImages/assets/${TILE_MAPPER_VERSION}/pkr_icon_tournaments@2x.png`
};
